export default "__VITE_ASSET__6f1a032d__"